import { Home, Thermometer, Sun, Sparkles } from "lucide-react";
import GrowthRing from "@/components/visuals/GrowthRing";

const ICON_MAP = {
  Home,
  Thermometer,
  Sun,
};

/**
 * Branded illustrated hero for campaign pages when a licensed photo isn't
 * available. Uses the Green Circle GrowthRing + audience icon inside a
 * deep-forest panel so the visual language stays authentic and consistent.
 */
export default function CampaignHeroVisual({
  iconName = "Sun",
  accent = "#8DFE3F",
  label,
  className = "",
}) {
  const Icon = ICON_MAP[iconName] || Sun;
  return (
    <div
      className={
        "relative aspect-[4/5] rounded-[3rem] overflow-hidden border-4 border-white shadow-[0_30px_80px_rgba(3,34,26,0.18)] bg-forest " +
        className
      }
      aria-hidden="true"
    >
      <div className="absolute inset-0 opacity-70">
        <GrowthRing size={520} colorFrom="#2CD59C" colorTo={accent} duration={90} />
      </div>
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background: `radial-gradient(circle at 70% 30%, ${accent}25, transparent 60%)`,
        }}
      />
      <div className="relative h-full w-full flex flex-col items-center justify-center p-8 text-center">
        <div
          className="inline-flex h-24 w-24 items-center justify-center rounded-3xl mb-6"
          style={{
            background: `linear-gradient(135deg, ${accent}, #2CD59C)`,
          }}
        >
          <Icon className="h-12 w-12 text-forest" strokeWidth={2} />
        </div>
        {label && (
          <p className="text-white/70 text-xs font-bold uppercase tracking-[0.24em] flex items-center gap-2">
            <Sparkles className="h-3 w-3" style={{ color: accent }} />
            {label}
          </p>
        )}
      </div>
    </div>
  );
}
